import { RANGE, CHECKBOX, SELECT } from '../constants';
const parseFilterValue = (key, type, value) => {
  if (!value) return null;
  switch (type) {
    case RANGE:
      if (value.minValue === value.min && value.maxValue === value.max) return null;
      return `${key}=${value.minValue}-${value.maxValue}`;
    case CHECKBOX:
      if (typeof value === 'string') return `${key}=${encodeURIComponent(value)}`;
      return value.map(val => `${key}=${encodeURIComponent(val)}`).join('&');
    case SELECT:
      {
        const parsedValue = encodeURIComponent(value);
        return `${key}=${parsedValue}`;
      }
    default:
      return null;
  }
};
export default parseFilterValue;
//# sourceMappingURL=parse-filter-value.js.map